import { useCallback, useMemo } from 'react';

import { useReportSchedulerContext } from '../../ReportSchedulerPopup.context';
import { options } from './RuleTypeSection.constants';

export const useRuleTypeSection = (ruleIndex: number) => {
    const { schedule, updateRuleConfig } = useReportSchedulerContext();

    const value = useMemo(
        () => options.find((option) => option.id === schedule.rules[ruleIndex].configuration.scheduleOptions)?.id,
        [ruleIndex, schedule.rules]
    );

    const handleChange = useCallback(
        (value: (typeof options)[number]['id']) => {
            updateRuleConfig(ruleIndex, {
                scheduleOptions: value,
            });
        },
        [ruleIndex, updateRuleConfig]
    );

    return {
        value,
        handleChange,
    };
};
